/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { ETransportOperationTypeVO } from '@well/delivery-libs/etransport/domain-model';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root'
})
export class ETransportOperationTypeSelectableResourceService extends SelectableResourceService<ETransportOperationTypeVO> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('eTransportOperationTypeUrl')}/resource-list`,
      ETransportOperationTypeVO,
      true
    );
  }
}
